import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "./link";

interface ILink {
  icon: any;
  title: string;
  url: string;
  newPage?: boolean;
  submenus?: ILink[];
  setOpened?: any;
}

export const ExpendableLink: React.FC<ILink> = ({
  icon,
  title,
  url,
  submenus = [],
  setOpened = () => null,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpened, setIsOpened] = React.useState(false);

  React.useEffect(() => {
    const submenuIsOpened = submenus
      ?.map((menu) => menu.url)
      .includes(location.pathname);

    if (submenuIsOpened) {
      setIsOpened(true);
      setOpened(true);
    }
  }, []);

  React.useEffect(() => {
    window.scroll(0, 0);
  }, [location]);

  return (
    <div onClick={() => navigate(url)}>
      <div
        className={`relative flex items-center cursor-pointer pl-3 py-1 h-full justify-between ${
          location.pathname === url
            ? "text-black bg-gray-200"
            : "text-gray-500 hover:bg-gray-50"
        } 
    
    rounded`}
      >
        <Link to={url} className=" flex flex-1 py-3 items-center">
          <span className="inline-block font-extralight mr-1">{icon}</span>
          <span className="font-normal text-xs">{title}</span>
        </Link>

        {submenus?.length > 0 && (
          <span
            className={`inline-block ml-auto transition-all p-2 ${
              isOpened ? "" : " -rotate-90"
            }`}
            onClick={() => setIsOpened((prev) => !prev)}
          >
            <svg
              className="text-gray-400 w-3 h-3"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.08329 0.666626C8.74996 0.333293 8.24996 0.333293 7.91663 0.666626L4.99996 3.58329L2.08329 0.666626C1.74996 0.333293 1.24996 0.333293 0.916626 0.666626C0.583293 0.999959 0.583293 1.49996 0.916626 1.83329L4.41663 5.33329C4.58329 5.49996 4.74996 5.58329 4.99996 5.58329C5.24996 5.58329 5.41663 5.49996 5.58329 5.33329L9.08329 1.83329C9.41663 1.49996 9.41663 0.999959 9.08329 0.666626Z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
        )}
      </div>
      <div className={` ${isOpened ? "" : "hidden"} pl-3 my-2 `}>
        {submenus?.map((menu, index) => (
          <ExpendableLink
            key={`${menu.url}-${index}`}
            setOpened={setIsOpened}
            icon={menu.icon}
            title={menu.title}
            url={menu.url}
            submenus={menu.submenus}
            newPage={menu.newPage || false}
          />
        ))}
      </div>
    </div>
  );
};
